"use strict";

function postrender(parts, options) {
	for (var i = 0, l = options.modules.length; i < l; i++) {
		var _module = options.modules[i];
		parts = _module.postrender(parts, options);
	}
	return parts.join("");
}

module.exports = postrender;


//////////////////
// WEBPACK FOOTER
// ./node_modules/docxtemplater/js/postrender.js
// module id = 556
// module chunks = 0